export default "__VITE_ASSET__CZaHNzIY__";